// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ccfqbVUd7\\+LtXsDDGHOF0w\\=\\={margin-right:1rem}", "",{"version":3,"sources":["webpack://./resources/js/components/PostView/DeveloperPostContent/DeveloperPostSections/BuildingProperties/AmenityList/HomeStead/styles.module.scss"],"names":[],"mappings":"AAAA,6BACI,iBACJ","sourcesContent":[".homestead_icon {\n    margin-right: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homestead_icon": "ccfqbVUd7+LtXsDDGHOF0w=="
};
export default ___CSS_LOADER_EXPORT___;
